import React, { useRef, useState, useEffect, } from 'react'
import PlayerAction from './PlayerAction'
import ChipsStack from './ChipsStack'
import Lottie from '../lotties/lottie'
import ReduceBigNumbers from './ReduceBigNumbers'
import ReactGA from 'react-ga4'

function Viewport({ localMedia, soundEnabled, toggleSound, ownStream, avatar, participant, socket, user, mediaConnections, roomData, privateData, toggleGetChips, width }) {
  const [ remoteStream, setRemoteStream ] = useState( null )
  const [ isRemoteMuted, setIsRemoteMuted ] = useState( false )
  const [ playerAction, setPlayerAction ] = useState ( null )
  const videoRef = useRef( null )
  const currentSrcObject = useRef( null ) // Track the current srcObject
  const [ loudness, setLoudness ] = useState(0)

  useEffect(()=>{
    if( participant && participant.action ){
      setPlayerAction( participant.action ) 
    }
  },[ participant ])

  useEffect(() => {
    if( videoRef.current ) {
      let newSrcObject

      if( ownStream ){
        newSrcObject = localMedia
        handleVideoElem()
        
      }else{
        newSrcObject = remoteStream
        if( remoteStream.active ) handleVideoElem()
      }

      function handleVideoElem(){
        if (currentSrcObject.current !== newSrcObject) {
          currentSrcObject.current = newSrcObject // Update the tracked srcObject
          videoRef.current.srcObject = newSrcObject

          if( !ownStream ){
            console.log( remoteStream )
          }
          
          videoRef.current
            .play()
            .then(() => {})
            .catch((error) => {
              console.error( "Error playing video:", error )
            });
        }
      }
    }
  }, [ localMedia, remoteStream, ownStream ])

  useEffect(() => {
    let sound
    let showMeter

    if( ownStream ) {
      sound = localMedia;
      showMeter = soundEnabled ? true : false
    } else {
      sound = remoteStream;
      showMeter = isRemoteMuted ? false : true
    }
    if (sound && showMeter) {
      const setupAudioLoudnessMeter = () => {
        try {
          const stream = sound;
          const audioContext = new( window.AudioContext || window.webkitAudioContext )()
          const audioSource = audioContext.createMediaStreamSource( stream )
          const analyser = audioContext.createAnalyser()

          analyser.fftSize = 256;
          const dataArray = new Uint8Array( analyser.frequencyBinCount )
          audioSource.connect( analyser )

          const updateMeter = () => {
            analyser.getByteFrequencyData( dataArray )

            // Calculate the average loudness
            const average = dataArray.reduce(( sum, value ) => sum + value, 0 ) / dataArray.length
            const percentage = ( average / 255 ) * 100

            setLoudness( percentage ) // Update the loudness state

            requestAnimationFrame( updateMeter )
          };

          updateMeter()
        } catch ( error ) {
          console.error( 'Error accessing media devices:', error )
        }
      };

      setupAudioLoudnessMeter()
    } else {
      // Reset loudness to 0 if showMeter is false
      setLoudness( 0 )
    }
  }, [ localMedia, remoteStream, isRemoteMuted, soundEnabled ])

  useEffect(() => {
    if ( !ownStream && mediaConnections && mediaConnections.length && participant && participant.participant ) {
      const connection = mediaConnections.find(
        ( conn ) => conn._id === participant.participant._id
      )
  
      if( connection && connection.remoteStream !== remoteStream ) {
        setRemoteStream( connection.remoteStream ) // Only update if the remoteStream is different
      }
    }
  }, [ ownStream, mediaConnections, participant, remoteStream ])

  function currentPlayer( status ) {
    if( status ){return ' currentPlayer'
    }else{
      return ""
    }
  }

  function isDealer(){
    if( participant.dealer ) return( <div className='dealerBadge' title="Dealer">D</div> )
  }

  function isWinner() {
    if( participant.winner && participant.winner.isWinner ){
      let bigWinSalut = ()=>{
        if ( participant.winner.sum >= participant.buyIn * 5 ){
          return(
            <Lottie
            animationName = 'confetti2'
            loop = { false }
            className = 'confettiBackground'
          />
          )
        }
      }
      return(
        <div className='winnerInfo'>
            { bigWinSalut() }
            <div className='winnerInfor_hand' >{ participant.winner.handName }</div>
            <div className='winnerInfor_sum'>{'$ ' + ReduceBigNumbers( participant.winner.sum ) }</div>
        </div>
      )
    }
  } 

  function drawCards() {
    let thisIsCurrentsPlayerViewport = ()=>{
      if( user && user._id && participant && participant.participant && participant.participant._id === user._id ){
        return true
      }else{
        return false
      }
    }

    // is it current's player viewport or not
    let foldAction = ( card )=>{
      if( playerAction == 'fold' ){
        if( thisIsCurrentsPlayerViewport() ){
          if( card == 'leftCard' ) return 'cardsFoldActionForLeftCardCurrentPlayer'
          if( card == 'rightCard' ) return 'cardsFoldActionForRightCardCurrentPlayer'
        }else{
          if( card == 'leftCard' ) return 'cardsFoldActionForLeftCard'
          if( card == 'rightCard' ) return 'cardsFoldActionForRightCard'
        }
      }else{
        return ''
      }
    }
    
    let currentPlayerIsAWinner = ()=>{
      if( participant && participant.winner && participant.winner.isWinner ){
        return true
      }else{
        return false
      }
    }

    let thereIsAWinner = ()=>{
      return(
        roomData.participants.some(( participant )=>{
          if( participant.winner && participant.winner.isWinner ){
            return participant.winner.isWinner === true
          }
        })
      )
    }

    // won cards:
    // if current player is the winner, cards from his winner.evaluatedCards
    // if there is no winner, cards from private data evaluated cards
    let wonCards = ()=>{
      let c = []
      if( currentPlayerIsAWinner() && participant.winner && participant.winner.evaluatedCards && participant.winner.evaluatedCards.length ){
        c = participant.winner.evaluatedCards.split(',')
      }
      if( !currentPlayerIsAWinner() && privateData && privateData.evaluatedCards && privateData.evaluatedCards.cards && privateData.evaluatedCards.cards.length ){
        c = privateData.evaluatedCards.cards.split(',')
      }
      return( c )
    }

    let shownCards = ()=>{
      let c = []
      if( thisIsCurrentsPlayerViewport() && privateData.cards && privateData.cards.length ){
        c = privateData.cards
      }else{
        if( participant.cards && participant.cards.length ){
          c = participant.cards
        }
      }
      return c
    }

    let evaluatedCardName = ()=>{
      let e = null
      
      if( privateData.evaluatedCards.name && thisIsCurrentsPlayerViewport() ){
      // if( privateData.evaluatedCards.name && thisIsCurrentsPlayerViewport() && ( participant.winner && !participant.winner.isWinner )){
        e = <div className='cardsName'>{ privateData.evaluatedCards.name }</div>
      }

      return e
    }

    // compare cards to current player hand cards. If match, highlight as own or as someone's else cards
    function highlight( shownCard, currentPlayerIsAWinner ) {
      let h = ''
      
      wonCards().map(( wonCard )=>{
        if( wonCard[ 0 ] == '1' ){
          wonCard = 'T' + wonCard[2]
        }

        if( shownCard && wonCard.toUpperCase() == shownCard.toUpperCase() ){
          if( currentPlayerIsAWinner ){
            h = 'highlightWinningCards'
          }else{
             if( !thereIsAWinner() ){
              h = 'highlight'
            }
          }
        }else{
          if( h =='' ) h = 'muffle'
          return
        }
      })
      
      return( h )
    }

    if( privateData.cards && privateData.cards.length ){
      return(

        // <div className={'cardHolder ' + foldAction() }>
        <div className='cardHolder'>
          { evaluatedCardName() }
          <div className={ 'leftCard cardInRoom ' + foldAction( 'leftCard' ) + ' ' + highlight( shownCards()[ 0 ], currentPlayerIsAWinner() )}>
              { drawCardsSuite( shownCards()[ 0 ], highlight( shownCards()[ 0 ], currentPlayerIsAWinner() ) )}
          </div>
          <div
              className={'rightCard cardInRoom ' + foldAction( 'rightCard' ) + ' ' + highlight( shownCards()[ 1 ], currentPlayerIsAWinner() )}>
              { drawCardsSuite( shownCards()[ 1 ], highlight( shownCards()[ 1 ], currentPlayerIsAWinner() ) )}
          </div>
        </div>
      )
    }
  }


  function drawCardsSuite( suite, highlight ) {
    // S H D C
    if( suite && suite.length ){
      const drawValue =( value ) => {
        return value !== 'T' ? value : '10'
    }

    if( suite === 'back' ){
      return (
        <div className="cardCover">
        <img className="cardCoverImage" src="images/cardCover.png" alt="🎆" />
      </div>
      )
    }else{
      switch( suite[ 1 ] ) {
        case 'S':
          return (
            <div className="black">
              <span className="cardValue">{ drawValue( suite[ 0 ])}</span>
              <span className="cardSuite">♠</span>
            </div>
          )
        case 'C':
          return (
            <div className="black cardSuiteHolder">
              <span className="cardValue">{ drawValue( suite[ 0 ])}</span>
              <span className="cardSuite">♣</span>
            </div>
            )
        case 'H':
          return (
            <div className={ highlight == 'muffle' ? 'darkRed cardSuiteHolder' : 'red cardSuiteHolder' }>
              <span className="cardValue">{ drawValue( suite[ 0 ])}</span>
              <span className="cardSuite">♥</span>
            </div>
          )
        case 'D':
          return (
            <div className={ highlight == 'muffle' ? 'darkRed cardSuiteHolder' : 'red cardSuiteHolder' }>
              <span className="cardValue">{ drawValue( suite[ 0 ])}</span>
              <span className="cardSuite">♦</span>
            </div>
          )
        default:
          return null
        }
      }
    }
  }

  function toggleViewportSound (){ 
    if( ownStream ) {
      toggleSound()

      ReactGA.event({
        category: 'Sound',
        action: 'Toggle Own Sound',
        label: soundEnabled ? 'Sound Muted' : 'Sound Unmuted'
      });
    }else{
      setIsRemoteMuted(( prev ) => !prev )

      ReactGA.event({
        category: 'Sound',
        action: 'Toggle Remote Sound',
        label: isRemoteMuted ? 'Sound Unmuted' : 'Sound Muted'
      })
    }
  }

  function soundIsUnmuted(){
    if( ownStream ){
      return soundEnabled
    }else{
      return !isRemoteMuted
    }
  }


  return (
    <div className="viewportInternalHolder">
      <div className="vieport_soundMeterHolder" onClick={ toggleViewportSound }>
        { 
          soundIsUnmuted() ?
          <div className='viewport_soundMeterHolder_microphoneIconUnmuted_holder'>
            <svg className='viewport_soundMeterHolder_microphoneIcon' viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.53418 6.47141C9.53418 3.56336 11.8971 1.19922 14.8064 1.19922C17.7158 1.19922 20.0786 3.5635 20.0786 6.47141V14.4817C20.0786 17.3897 17.7157 19.7539 14.8064 19.7539C11.8983 19.7539 9.53418 17.391 9.53418 14.4817V6.47141ZM13.7426 26.6663V24.3244C8.78332 23.7904 4.91016 19.5781 4.91016 14.4839V12.238C4.91016 11.6469 5.38714 11.1699 5.97819 11.1699C6.56925 11.1699 7.04623 11.6469 7.04623 12.238V14.4839C7.04623 18.7659 10.5273 22.2482 14.8105 22.2482C19.0926 22.2482 22.5748 18.7671 22.5748 14.4839V12.238C22.5748 11.6469 23.0518 11.1699 23.6428 11.1699C24.2339 11.1699 24.7109 11.6469 24.7109 12.238V14.4839C24.7109 19.5824 20.8378 23.7904 15.8785 24.3244V26.6663H18.6307C19.2218 26.6663 19.6987 27.1433 19.6987 27.7344C19.6987 28.3254 19.2218 28.8024 18.6307 28.8024H10.9946C10.4035 28.8024 9.92655 28.3254 9.92655 27.7344C9.92655 27.1433 10.4035 26.6663 10.9946 26.6663H13.7426Z" fill="white"/>
            </svg>
          </div>
          :
          <div className='viewport_soundMeterHolder_microphoneIcon_holder'>
            <svg className='viewport_soundMeterHolder_microphoneIcon' viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.46415 5.38793C9.4655 5.38153 9.46686 5.37513 9.46823 5.36873L17.8037 18.6893C17.8001 18.692 17.7964 18.6948 17.7928 18.6975L19.1184 20.8159C19.1221 20.8132 19.1258 20.8106 19.1295 20.8079L20.2629 22.6192C20.2592 22.6218 20.2554 22.6243 20.2517 22.6269L22.122 25.6158C22.4349 26.1158 22.2832 26.7748 21.7832 27.0877C21.2831 27.4006 20.6241 27.2489 20.3112 26.7489L18.3715 23.6491C17.5295 23.9946 16.6297 24.2273 15.691 24.3284V26.6702H18.4432C19.0343 26.6702 19.5112 27.1472 19.5112 27.7383C19.5112 28.3293 19.0343 28.8063 18.4432 28.8063H10.8071C10.216 28.8063 9.73905 28.3293 9.73905 27.7383C9.73905 27.1472 10.216 26.6702 10.8071 26.6702H13.5551V24.3284C8.59582 23.7943 4.72266 19.582 4.72266 14.4878V12.2419C4.72266 11.6508 5.19964 11.1738 5.79069 11.1738C6.38175 11.1738 6.85873 11.6508 6.85873 12.2419V14.4878C6.85873 18.7699 10.3398 22.2521 14.623 22.2521C15.5328 22.2521 16.4065 22.0949 17.2184 21.8063L15.847 19.6148C15.4543 19.7083 15.0448 19.7578 14.6238 19.7578C11.7157 19.7578 9.35156 17.3949 9.35156 14.4856V9.23482L7.29525 5.94873C6.98235 5.4487 7.13405 4.78969 7.63408 4.47679C8.13411 4.16389 8.79312 4.31559 9.10602 4.81562L9.46415 5.38793ZM20.709 19.3052L21.8942 21.1993C23.5255 19.4342 24.5234 17.0757 24.5234 14.4878V12.2419C24.5234 11.6508 24.0464 11.1738 23.4553 11.1738C22.8643 11.1738 22.3873 11.6508 22.3873 12.2419V14.4878C22.3873 16.3066 21.7594 17.9808 20.709 19.3052ZM10.5715 3.10493L19.2617 16.9923C19.6662 16.2464 19.8959 15.3925 19.8959 14.4856V6.47532C19.8959 3.5674 17.5332 1.20312 14.6238 1.20312C12.9958 1.20312 11.539 1.94336 10.5715 3.10493Z" fill="white"/>
            </svg>
            { width > 1000 ? <div className='viewport_soundMeterHolder_microphoneIcon_badge'>Muted</div> : null }
            
          </div>
        }
        {/* {
          soundIsUnmuted() ? null : <div className='viewport_soundMeterHolder_microphoneIcon_badge'>Muted</div>
        } */}
        {
          !soundIsUnmuted() ? null :
          <div
            className="viewport_soundMeterCircle"
            style={{
              width: `${Math.min(3, 1 + loudness / 30)}rem`, // Cap the width at 3rem
              height: `${Math.min(3, 1 + loudness / 30)}rem`, // Cap the height at 3rem
              opacity: `${Math.min(loudness / 400, 0.3)}`,
              border: `${loudness * 0.05}rem solid rgb(1, 254, 9)`
            }}
          ></div>
        }
        {
          !soundIsUnmuted() ? null :
          <div
            className="viewport_soundMeterCircle"
            style={{
              width: `${Math.min(3, 1 + loudness / 80)}rem`, // Cap the width at 3rem
              height: `${Math.min(3, 1 + loudness / 80)}rem`, // Cap the height at 3rem
              opacity: `${Math.min(loudness / 400, 0.9)}`,
              border: `${loudness * 0.05}rem solid rgb(1, 254, 9)`
            }}
          ></div>
        }

      </div>
      <div className='viewport_topPanel' >
        {/* <span>{"UU " + loudness}</span> */}
        <span className='viewport_username'>{ participant.participant.first_name }</span>
        { width <= 1000 ? <span className='viewport_userStack_span'>{ participant.buyIn ? '$ ' + ReduceBigNumbers( participant.buyIn ) : '0' }</span> : null}
      </div>
      <div className = { 'player' + currentPlayer( participant.currentPlayer ) }>
        { isDealer() }
        { isWinner() }
        <PlayerAction
          time = { roomData.gameConfig ? roomData.gameConfig.time : null }
          action = { participant.action }
          currentBet = { participant.currentBet }
          currentPlayer = { participant.currentPlayer }
        />
        { drawCards() }
        <div className='videoHolder'>
          {
            ownStream ?
              <video ref={videoRef} className={"localVideo" + " " + ownStream} muted autoPlay></video>
              :
              remoteStream ? participant.status === 'left' ?
                <img className='viewport_background' src={ 'images/petAvatars/' + avatar + '.jpeg' } alt='Avatar' />
                :
                <video ref={videoRef} className="localVideo" muted={ isRemoteMuted } autoPlay></video> 
                :
                <img className='viewport_background' src={ 'images/petAvatars/' + avatar + '.jpeg' } alt='Avatar' />
          }
        </div>
      </div>
      <ChipsStack
          buyIn={ participant.buyIn }
          currentBet={ participant.currentBet }
          smallBlind={ roomData?.gameConfig?.smallBlind }
          className = "viewport_participantChipsContainer"
          betChips = { true }
          participant = { participant } 
          roomData = { roomData } 
          user = { user }
          toggleGetChips={ toggleGetChips }
          socket ={ socket }
          width={ width }
          showBetChips = { true }
        />
      { width >= 1000 ? <div className = 'viewportParticipantBuyIn'><p>{ participant.buyIn > 0 ?  "$ " +  ReduceBigNumbers( participant.buyIn ) : null }</p></div> : null }
    </div>
  )
}

export default Viewport